import {
    ADD_TO_CART,
} from "../actionTypes";

export const reducers1 = (state = "false", action) => {
    switch (action.type) {
        case ADD_TO_CART:
            return action.payload;
        default:
            return state;
    }
}